  (function() {
    async function runFulfillmentCart(cartRoot, skipRefresh) {
      if (!window.FulfillmentCartWriter || !cartRoot) {
        return null;
      }
      var result = await FulfillmentCartWriter.run(cartRoot);
      if (result && result.updated && !skipRefresh && window.CartPage) {
        window.CartPage.updateCart(true);
        return result;
      }
      return result;
    }

    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function(skipFulfillmentRefresh) {
      $s.showLoadingOverlay();
      $s.getJson({url: routes.root_url + '?sections=cart_content', success: async function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        window.__fulfillmentSkipCartRefresh = !!skipFulfillmentRefresh;
        await $s.globalEval(data['cart_content']);
        window.__fulfillmentSkipCartRefresh = false;
        if (window.affirm && affirm.ui && affirm.ui.refresh) {
          affirm.ui.refresh();
        }
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    self.updateItemsQuantityWithUpdates = function(updates) {
      postUpdate({ updates: updates });
    }

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.updateCartItemsQuantity(data).then(async function(cart) {
        self.updateCart();
      }).catch($s.addToCartFail);      
    }
  
  };
  //runs every time #cart div is replaced
  if (window.CartCache && CartCache.cart_fetch === null) {
    $s.get({url:'/cart.js'}); //trigger fetch to cache
  }
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = document.querySelector('header .cart-count');
  if(cartCountElement) {
    cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
  }
  var cartCountElementCart = document.querySelector('#cart .cart-count');
  if(cartCountElementCart) {
    cartCountElementCart.innerHTML = itemsCount>0?itemsCount:'';
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', async function(e){
      var itemEl = this.closest('.item');
      var qty = this.value / 1;
      if (itemEl.dataset.bundleId && itemEl.dataset.bundleItem !== 'individual' && $s.getBundleQuantityUpdates) {
        var updates = await $s.getBundleQuantityUpdates(itemEl, qty);
        CartPage.updateItemsQuantityWithUpdates(updates);
        return;
      }
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(itemEl, qty) : [itemEl];
      CartPage.updateItemsQuantity(items, qty);
    });
  });

  
  

  if ($s.validateBundlesInJson) {
    $s.getJson({url:'/cart.js'}).then(data=>{
      $s.validateBundlesInJson(data.items);
    })
  }

  runFulfillmentCart(cart, !!window.__fulfillmentSkipCartRefresh);

})();
document.addEventListener('click', function(e) {
  if (e.target.closest('#cart-apply-promo-btn')) {
    e.preventDefault();
    var input = document.getElementById('cart-discount-input');
    var code = input && input.value ? input.value.trim() : '';
    if (code) location = routes.checkout_url + '?discount=' + encodeURIComponent(code);
  }
});